import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class MachineListHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getAllMachines(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_all_machines';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  console.log(response);
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
